module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "navbar",
    attrs: {
      "mode": "horizontal"
    }
  }, [_c('hamburger', {
    staticClass: "hamburger-container",
    attrs: {
      "toggleClick": _vm.toggleSideBar,
      "isActive": _vm.sidebar.opened
    }
  }), _vm._v(" "), _c('breadcrumb'), _vm._v(" "), _c('el-dropdown', {
    staticClass: "avatar-container",
    attrs: {
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "avatar-wrapper"
  }, [_c('svg-icon', {
    staticClass: "svg-icon",
    staticStyle: {
      "font-size": "32px"
    },
    attrs: {
      "icon-class": "avatar"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })], 1), _vm._v(" "), _c('el-dropdown-menu', {
    staticClass: "user-dropdown",
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('router-link', {
    staticClass: "inlineBlock",
    attrs: {
      "to": "/admin"
    }
  }, [_c('el-dropdown-item', [_vm._v("\n            主页\n          ")])], 1), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f749f46","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Navbar.vue
// module id = aGF1
// module chunks = 3